import DataService from "@/services/DataService";

export default {
  getAll() {
    return DataService.apiClient.get("/notification");
  },
  get(id) {
    return DataService.apiClient.get(`/notification/${id}`);
  },

  save(item) {
    //console.log(item);
    if (item._id != null) {
      return DataService.apiClient.patch(`/notification/${item._id}`, item);
    } else {
      return DataService.apiClient.post("/notification/", item);
    }
  },

  send(item) {
    //console.log(item);

    return DataService.apiClient.post("/notification/send", item);
  },
  delete(id) {
    return DataService.apiClient.delete("/notification/delete/" + id);
  }
};
